import { render, staticRenderFns } from "./BuildWheel.vue?vue&type=template&id=2fd53ea0&scoped=true"
import script from "./BuildWheel.vue?vue&type=script&lang=js"
export * from "./BuildWheel.vue?vue&type=script&lang=js"
import style0 from "./BuildWheel.vue?vue&type=style&index=0&id=2fd53ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd53ea0",
  null
  
)

export default component.exports